import { render, staticRenderFns } from "./SocialDeliverableCampaigns.vue?vue&type=template&id=993af3fc&scoped=true&"
import script from "./SocialDeliverableCampaigns.vue?vue&type=script&lang=js&"
export * from "./SocialDeliverableCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./SocialDeliverableCampaigns.vue?vue&type=style&index=0&id=993af3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993af3fc",
  null
  
)

export default component.exports